import { WebhookEventsEnum } from '../../enums';

export interface IWebhookSchema {
    id: string;
    name: string;
    description?: string;
    url: string;
    secret?: string;
    events: WebhookEventsEnum[];
    enabled: boolean;
}
